export default __webpack_public_path__ + "static/media/dance002.80017746.gif";